
import "../../styles/editor.css";

import { Header } from "../../components/header/header";
import { TextInputEditor } from "../../components/editor";
import { PageSupport } from "../../components/utilities/page-support";

export const MbeiAdmin = () => {
    return (
        <div className="f-pg">
            <PageSupport />
            <Header pageTitle={"Admin page"} />
            <TextInputEditor />
        </div>
    );
}